exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".w10[data-v-41cf84e6] {\n  width: 10%;\n}\n.w20[data-v-41cf84e6] {\n  width: 20%;\n}\n.small-text[data-v-41cf84e6] {\n  font-size: 0.79rem;\n}\n.spinner[data-v-41cf84e6] {\n  height: 20px;\n  width: 20px;\n  border-radius: 50%;\n  display: inline-block;\n  vertical-align: middle;\n}\n.spinner--1[data-v-41cf84e6] {\n  border-top: 2px solid #c7c7c7;\n  animation: spinner1-41cf84e6 600ms linear infinite;\n}\n@keyframes spinner1-41cf84e6 {\nto {\n    transform: rotate(360deg);\n}\n}", ""]);

// exports
